import { useReadContract } from "wagmi";

const useGetAllWhiteListedAddresses = (address, abi, provider) => {
  return useReadContract({
    address: address,
    abi: abi,
    functionName: "getAllWhitelistedAddresses",
    args: [],
    provider: provider
  });
};

export default useGetAllWhiteListedAddresses;